/* Lockdown Security: vehicle hub pages (Guided). Used by sections/lds-vehicle-hub.liquid. */
(function () {
  function initHub(root) {
    if (!root || root.dataset.ready) return;
    root.dataset.ready = '1';
    var sid = root.dataset.sid;
    var mode = root.dataset.mode;
    var handle = root.dataset.handle;
    var title = root.dataset.title;
    var cfgEl = root.querySelector('[data-vh-config]');
    var cfg = [];
    try { cfg = JSON.parse(cfgEl ? cfgEl.textContent : '[]'); } catch (e) { cfg = []; }
    function tpl(name) { var t = document.getElementById('lds-vh-' + name + '-' + sid); return t ? t.innerHTML : ''; }

    // Same rules as Shopify's handleize for the names we use: lowercase, anything else becomes a hyphen.
    function slug(s) { return String(s || '').toLowerCase().replace(/&/g, '').replace(/['’]/g, '').replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, ''); }
    function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }

    function parseCSV(text) {
      text = text.replace(/^﻿/, '');
      var rows = [], row = [], field = '', q = false;
      for (var i = 0; i < text.length; i++) {
        var c = text[i];
        if (q) {
          if (c === '"') { if (text[i + 1] === '"') { field += '"'; i++; } else { q = false; } }
          else field += c;
        } else if (c === '"') q = true;
        else if (c === ',') { row.push(field); field = ''; }
        else if (c === '\n' || c === '\r') {
          if (c === '\r' && text[i + 1] === '\n') i++;
          row.push(field); field = '';
          if (row.length > 1 || row[0] !== '') rows.push(row);
          row = [];
        } else field += c;
      }
      if (field !== '' || row.length) { row.push(field); rows.push(row); }
      var head = (rows.shift() || []).map(function (h) { return h.trim(); });
      return rows.map(function (r) { var o = {}; head.forEach(function (h, k) { o[h] = (r[k] || '').trim(); }); return o; });
    }

    function yearsLabel(a, b) { return a === b ? String(a) : a + '–' + b; }
    function pagePath(p) { if (!p) return ''; try { var u = new URL(p, location.origin); return u.pathname + u.search; } catch (e) { return p; } }

    // The file lives in Content > Files. Try it through the store's own domain first (/cdn/shop/files/...),
    // then the address Shopify gave, so a CDN cross-site rule can't break the page.
    function sources() {
      var src = root.dataset.src || '', list = [src];
      try {
        var u = new URL(src, location.href);
        var m = /\/files\/([^\/]+)$/.exec(u.pathname);
        if (u.origin !== location.origin && m) list.unshift('/cdn/shop/files/' + m[1] + u.search);
      } catch (e) {}
      return list;
    }
    var lastMod = '';
    function fetchFirst(list) {
      var i = 0;
      function next(err) {
        if (i >= list.length) return Promise.reject(err || new Error('No fitment file'));
        var url = list[i++];
        return fetch(url, { credentials: 'same-origin' })
          .then(function (r) { if (!r.ok) throw new Error('Fitment file ' + r.status + ' at ' + url); lastMod = r.headers.get('Last-Modified') || ''; return r.text(); })
          .catch(next);
      }
      return next();
    }

    function load() {
      return fetchFirst(sources())
        .then(function (t) {
          return parseCSV(t).filter(function (r) {
            var st = (r['Status'] || 'Live').toLowerCase();
            return st === 'live' && r['Make'] && r['Model'];
          }).map(function (r) {
            var a = parseInt(r['Year Start'], 10), b = parseInt(r['Year End'], 10) || a;
            return {
              make: r['Make'], model: r['Model'], key: slug(r['Make'] + ' ' + r['Model']), makeKey: slug(r['Make']),
              ys: Math.min(a, b), ye: Math.max(a, b), cat: r['Category'], start: r['Start Type'] || '', variant: r['Variant'] || '',
              page: pagePath(r['Page']), products: (r['Products'] || '').split(',').map(function (x) { return x.trim().toLowerCase(); }).filter(Boolean),
              preferred: (r['Preferred'] || '').trim().toLowerCase(),
              added: (r['Added'] || '').trim(), change: (r['Change'] || '').trim()
            };
          }).filter(function (r) { return r.ys > 1900; });
        })
        .then(function (rows) { try { fillUpdated(rows); } catch (e) { console.warn('[vehicle hub] list date', e); } return rows; })
        .then(pairUp);
    }

    // "Vehicle list updated ..." dropdown: the date comes from the file itself (Liquid reads it from the file
    // address, the Last-Modified header is the fallback); the counts are worked out from the rows.
    function fillUpdated(rows) {
      var box = root.querySelector('[data-vh-updated]');
      if (!box) return;
      var makes = {}, models = {}, maxY = 0, cap = new Date().getFullYear() + 1;
      rows.forEach(function (r) { makes[r.makeKey] = 1; models[r.key] = 1; if (r.ye > maxY) maxY = r.ye; });
      maxY = Math.min(maxY, cap);
      var nMk = Object.keys(makes).length, nMd = Object.keys(models).length;
      var mdTxt = nMd >= 100 ? (Math.floor(nMd / 10) * 10) + '+' : String(nMd);
      var dEl = box.querySelector('[data-vh-upd-date]'), eye = box.querySelector('[data-vh-upd-eye]');
      // What's new: rows carry the date they were added (optional "Added" column, YYYY-MM-DD, plus an optional
      // "Change" note such as "New vehicle" or "New years"). The newest date in the file is this update.
      var latest = '';
      rows.forEach(function (r) { if (/^\d{4}-\d{2}-\d{2}$/.test(r.added) && r.added > latest) latest = r.added; });
      function fmtDay(iso) { var d = new Date(iso + 'T12:00:00'); return isNaN(d.getTime()) ? iso : d.toLocaleDateString('en-CA', { month: 'short', day: 'numeric', year: 'numeric' }); }
      // A date from the page that isn't a real one (a year outside 2000 to next year) is dropped for the header date.
      var tEl = dEl && dEl.querySelector('time'), ty = tEl ? parseInt(String(tEl.getAttribute('datetime') || ''), 10) : 0;
      if (tEl && !(ty >= 2000 && ty <= cap)) { dEl.innerHTML = ''; if (eye) eye.textContent = ''; }
      if (dEl && !dEl.textContent.trim() && lastMod) {
        var d = new Date(lastMod);
        if (!isNaN(d.getTime())) {
          var f = d.toLocaleDateString('en-CA', { month: 'short', day: 'numeric', year: 'numeric' });
          dEl.innerHTML = esc(box.dataset.label) + ' <time datetime="' + d.toISOString().slice(0, 10) + '">' + esc(f) + '</time>';
          if (eye) eye.textContent = (box.dataset.eye || 'Vehicle list · updated') + ' ' + f;
        }
      }
      if (dEl && !dEl.textContent.trim() && latest) {
        var fl = fmtDay(latest);
        dEl.innerHTML = esc(box.dataset.label) + ' <time datetime="' + latest + '">' + esc(fl) + '</time>';
        if (eye) eye.textContent = (box.dataset.eye || 'Vehicle list · updated') + ' ' + fl;
      }
      if (!dEl || !dEl.textContent.trim()) { box.hidden = true; return; }
      var sh = box.querySelector('[data-vh-upd-short]');
      if (sh) sh.textContent = ' · ' + nMk + ' makes · up to ' + maxY + ' models';
      var h = box.querySelector('[data-vh-upd-h]');
      if (h) h.textContent = String(box.dataset.title || '[makes] makes, [models] models').replace('[makes]', nMk).replace('[models]', mdTxt);
      var tl = box.querySelector('[data-vh-upd-tiles]');
      if (!tl) return;
      var groups = [{ k: 'newest', n: maxY, label: box.dataset.newest || 'Newest model year', rows: rows.filter(function (r) { return r.ye >= maxY; }) }];
      TYPES.forEach(function (t) {
        var rs = rows.filter(function (r) { return t.cats.indexOf(r.cat) > -1; });
        var seen = {}; rs.forEach(function (r) { seen[r.key] = 1; });
        if (rs.length) groups.push({ k: t.key, n: Object.keys(seen).length, label: t.label, rows: rs, type: t });
      });
      groups.forEach(function (g) { g.fresh = latest ? g.rows.filter(function (r) { return r.added === latest; }) : []; });
      var nNew = 0, seenNew = {};
      rows.forEach(function (r) { var id = r.key + '|' + r.cat + '|' + r.ys + '|' + r.start + '|' + r.variant; if (latest && r.added === latest && !seenNew[id]) { seenNew[id] = 1; nNew++; } });
      var addEl = box.querySelector('[data-vh-upd-added]');
      if (addEl && nNew) { addEl.innerHTML = '<b>' + nNew + ' new</b> ' + (nNew === 1 ? 'listing' : 'listings') + ' added ' + esc(fmtDay(latest)) + '. Tap a box to see them.'; addEl.hidden = false; }
      var did = 'vh-upd-detail-' + sid;
      tl.innerHTML = groups.map(function (g, i) {
        return '<li class="lds-vh__upd-tile"><button type="button" class="lds-vh__upd-tbtn" data-upd-k="' + i + '" aria-expanded="false" aria-controls="' + did + '"><b>' + esc(g.n) + '</b><span>' + esc(g.label) + '</span>' +
          (g.fresh.length ? '<em class="lds-vh__upd-new">+' + g.fresh.length + ' new</em>' : '') + '</button></li>';
      }).join('');
      var det = document.createElement('div');
      det.className = 'lds-vh__upd-detail'; det.id = did; det.hidden = true; det.setAttribute('aria-live', 'polite');
      tl.parentNode.insertBefore(det, tl.nextSibling);
      // Model links open the model page filtered to that product (?type=), the same as the product buttons.
      function href(r, g) { return '/collections/' + encodeURIComponent(r.key) + (g.type ? '?type=' + encodeURIComponent(g.type.key) : ''); }
      function line(r, g) {
        var sub = [r.start, r.variant, r.change].filter(Boolean).join(' · ');
        return '<li><a href="' + esc(href(r, g)) + '">' + esc(yearsLabel(r.ys, r.ye) + ' ' + r.make + ' ' + r.model) + '</a>' + (sub ? ' <span>' + esc(sub) + '</span>' : '') + '</li>';
      }
      function show(i) {
        var g = groups[i], byMake = {}, names = {};
        g.rows.forEach(function (r) {
          names[r.makeKey] = r.make;
          var m = byMake[r.makeKey] = byMake[r.makeKey] || {};
          var x = m[r.key] = m[r.key] || { r: r, ys: r.ys, ye: r.ye };
          x.ys = Math.min(x.ys, r.ys); x.ye = Math.max(x.ye, r.ye);
        });
        var fresh = g.fresh.slice().sort(function (a, b) { return (a.make + ' ' + a.model).localeCompare(b.make + ' ' + b.model) || b.ye - a.ye; });
        var max = 40;
        var h = '<div class="lds-vh__upd-dhead"><p class="lds-vh__upd-dtitle">' + esc(g.label) + ' <span>' + esc(g.k === 'newest' ? 'models we cover for ' + maxY : g.n + ' models') + '</span></p>' +
          '<button type="button" class="lds-vh__upd-dclose" data-upd-close aria-label="Close">&times;</button></div>';
        if (fresh.length) {
          h += '<div class="lds-vh__upd-dnew"><p class="lds-vh__upd-dh">New in this update · ' + esc(fmtDay(latest)) + '</p><ul class="lds-vh__upd-dlist">' +
            fresh.slice(0, max).map(function (r) { return line(r, g); }).join('') + '</ul>' +
            (fresh.length > max ? '<p class="lds-vh__upd-dmore">and ' + (fresh.length - max) + ' more</p>' : '') + '</div>';
        }
        h += '<p class="lds-vh__upd-dh">' + (g.k === 'newest' ? 'Every model with ' + maxY + ' covered' : 'Every model covered') + '</p><div class="lds-vh__upd-makes">' +
          Object.keys(byMake).sort(function (a, b) { return names[a].localeCompare(names[b]); }).map(function (mk) {
            var ms = byMake[mk];
            return '<p class="lds-vh__upd-make"><b>' + esc(names[mk]) + '</b>' + Object.keys(ms).sort(function (a, b) { return ms[a].r.model.localeCompare(ms[b].r.model, undefined, { numeric: true }); }).map(function (k) {
              var x = ms[k];
              return '<a href="' + esc(href(x.r, g)) + '">' + esc(x.r.model) + ' <span>' + esc(yearsLabel(x.ys, x.ye)) + '</span></a>';
            }).join('') + '</p>';
          }).join('') + '</div>';
        det.innerHTML = h;
        det.hidden = false;
        Array.prototype.forEach.call(tl.querySelectorAll('[data-upd-k]'), function (b) { b.setAttribute('aria-expanded', b.getAttribute('data-upd-k') === String(i) ? 'true' : 'false'); });
      }
      function hide() {
        det.hidden = true; det.innerHTML = '';
        Array.prototype.forEach.call(tl.querySelectorAll('[data-upd-k]'), function (b) { b.setAttribute('aria-expanded', 'false'); });
      }
      box.addEventListener('click', function (e) {
        var b = e.target.closest ? e.target.closest('[data-upd-k], [data-upd-close]') : null;
        if (!b) return;
        e.preventDefault();
        if (b.hasAttribute('data-upd-close') || b.getAttribute('aria-expanded') === 'true') {
          var open = tl.querySelector('[aria-expanded="true"]');
          hide(); if (open) open.focus();
          return;
        }
        show(parseInt(b.getAttribute('data-upd-k'), 10));
      });
    }

    // "Models that show the same parts": Dodge RAM 1500 = RAM 1500 copies each side's rows to the
    // other (skipping exact repeats), so both pages, both make pages and the search page match.
    function pairUp(rows) {
      var lines = String(root.dataset.pairs || '').split(/[\n;]+/);
      var byKey = {}, makes = {};
      rows.forEach(function (r) { (byKey[r.key] = byKey[r.key] || []).push(r); makes[r.makeKey] = r.make; });
      function who(text) {
        var k = slug(text);
        if (byKey[k]) return byKey[k][0];
        var mk = Object.keys(makes).filter(function (m) { return k.indexOf(m + '-') === 0; }).sort(function (a, b) { return b.length - a.length; })[0];
        if (!mk) return null;
        return { make: makes[mk], makeKey: mk, key: k, model: String(text).trim().slice(makes[mk].length).trim() };
      }
      // Same category, start type, variant and years = the same line on the page. The page's own row wins
      // (its own fitment page); rows that only list products get the other side's products added.
      function sig(r) { return [r.cat, r.start, r.variant, r.ys, r.ye].join('|'); }
      var out = rows.slice(), adds = [];
      lines.forEach(function (line) {
        var p = line.split('=');
        if (p.length !== 2 || !p[0].trim() || !p[1].trim()) return;
        var a = who(p[0]), b = who(p[1]);
        if (!a || !b || a.key === b.key) { if (line.trim()) console.warn('[vehicle hub] Skipped model pair "' + line.trim() + '": make not in the fitment file.'); return; }
        [[a, b], [b, a]].forEach(function (x) {
          var from = byKey[x[0].key] || [], to = x[1], have = {};
          (byKey[to.key] || []).forEach(function (r) { have[sig(r)] = r; });
          from.forEach(function (r) {
            var s = sig(r), mine = have[s];
            if (mine) {
              if (!mine.page && !r.page) r.products.forEach(function (h) { if (mine.products.indexOf(h) < 0) adds.push([mine, h]); });
              return;
            }
            var c = {}; for (var f in r) c[f] = r[f];
            c.products = r.products.slice();
            c.make = to.make; c.makeKey = to.makeKey; c.model = to.model; c.key = to.key; c.paired = true;
            have[s] = c; out.push(c);
          });
        });
      });
      adds.forEach(function (x) { if (x[0].products.indexOf(x[1]) < 0) x[0].products.push(x[1]); });
      return out;
    }

    // ---------- Product types ("What are you looking for?") ----------
    // "Label = Category, Category" per line, from the section's "Product type buttons" setting. The search
    // narrows makes, models and years to vehicles that have that product; ?type=carplay carries the choice to
    // make and model pages, which then show only those boxes.
    var TYPES_DEFAULT = 'Remote starters = Remote Starters\nCarPlay = CarPlay Interfaces, CarPlay Screens\nStereos & install parts = Car Stereo Installation Parts, Custom Fit Car Stereos\nPower liftgates = Power Liftgate Kits\nBluetooth = Bluetooth Interfaces\nBackup cameras = Backup Cameras, Backup Camera Interfaces\nStrobe lights = Strobe Light Interfaces';
    var TYPES = String(root.hasAttribute('data-types') ? root.dataset.types : TYPES_DEFAULT).split(/\r?\n/).map(function (l) {
      var i = l.indexOf('='); if (i < 0) return null;
      var label = l.slice(0, i).trim(), cats = l.slice(i + 1).split(',').map(function (x) { return x.trim(); }).filter(Boolean);
      return label && cats.length ? { key: slug(label), label: label, cats: cats } : null;
    }).filter(Boolean);
    function typeByKey(k) { return TYPES.filter(function (t) { return t.key === k; })[0] || null; }
    var urlType = typeByKey(new URLSearchParams(location.search).get('type') || '');
    var activeType = null; // the type in force on this page, carried into VIN links
    function withType(url, t) {
      t = t === undefined ? activeType : t;
      return t ? url + (url.indexOf('?') > -1 ? '&' : '?') + 'type=' + encodeURIComponent(t.key) : url;
    }
    function inType(t, cat) { return !t || t.cats.indexOf(cat) > -1; }
    function setUrlType(t) {
      try {
        var u = new URL(location.href);
        if (t) u.searchParams.set('type', t.key); else u.searchParams.delete('type');
        history.replaceState(null, '', u.pathname + u.search + u.hash);
      } catch (e) {}
    }
    // A notice above the boxes when a page is filtered to one product type, with a way back to everything.
    function typeNote(before, html, btnLabel, onClear) {
      var p = document.createElement('div');
      p.className = 'lds-vh__typenote';
      p.innerHTML = '<p>' + html + '</p><button type="button" class="lds-vh__typenote-btn">' + esc(btnLabel) + '</button>';
      p.querySelector('button').addEventListener('click', onClear);
      before.parentNode.insertBefore(p, before);
      return p;
    }
    // "Don't see your vehicle?" line for filtered views: a text and call link, so a gap in the data becomes a lead.
    function attrOr(name, dflt) { return root.hasAttribute('data-' + name) ? root.getAttribute('data-' + name) : dflt; }
    var MISS = {
      text: attrOr('miss', "Don't see your vehicle? We may still have a solution."),
      sms: attrOr('miss-sms', '647-439-4485'),
      tel: attrOr('miss-tel', '1-866-824-4118')
    };
    function phoneHref(n) { var d = String(n).replace(/\D/g, ''); if (d.length === 10) d = '1' + d; return d ? '+' + d : ''; }
    function lowerLabel(l) { return /\s/.test(l) && /^[A-Z][a-z]+\b/.test(l) ? l.charAt(0).toLowerCase() + l.slice(1) : l; }
    function missHtml(t, vehicle) {
      if (!MISS.text) return '';
      var links = [];
      var sms = phoneHref(MISS.sms), tel = phoneHref(MISS.tel);
      if (sms) {
        var body = 'Hi, I\'m looking for ' + (t ? lowerLabel(t.label) : 'parts') + ' for my ' + (vehicle ? vehicle + ' ' : '');
        links.push('<a href="sms:' + sms + '?&amp;body=' + esc(encodeURIComponent(body)) + '">Text ' + esc(MISS.sms) + '</a>');
      }
      if (tel) links.push('<a href="tel:' + tel + '">' + (links.length ? 'call ' : 'Call ') + esc(MISS.tel) + '</a>');
      return esc(MISS.text) + (links.length ? ' <span class="lds-vh__miss-links">' + links.join(' or ') + '.</span>' : '');
    }

    // Height of a sticky or fixed site header, so a scroll doesn't land under it.
    function headerOffset() {
      var h = 0;
      Array.prototype.forEach.call(document.querySelectorAll('.shopify-section-group-header-group, .section-header, sticky-header, header'), function (el) {
        var cs = getComputedStyle(el), r = el.getBoundingClientRect();
        if ((cs.position === 'sticky' || cs.position === 'fixed') && r.height && r.height < window.innerHeight / 2) {
          h = Math.max(h, (cs.position === 'fixed' ? Math.max(r.top, 0) : (parseFloat(cs.top) || 0)) + r.height);
        }
      });
      return h;
    }
    // Height of the pinned "Jump to" bar on model pages (it shows once the page scrolls into the boxes).
    var pinEl = null;
    function jumpOffset() {
      var j = root.querySelector('[data-vh-jump]');
      return pinEl && j && !j.hidden ? pinEl.firstElementChild.offsetHeight + 16 : 0;
    }
    function scrollToId(id) {
      var el = document.getElementById(id);
      if (!el) return false;
      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var pinned = el.closest && el.closest('[data-vh-cats]') ? jumpOffset() : 0;
      window.scrollTo({ top: Math.max(0, el.getBoundingClientRect().top + window.pageYOffset - headerOffset() - pinned - 12), behavior: reduce ? 'auto' : 'smooth' });
      var f = el.matches('[tabindex="-1"]') ? el : el.querySelector('[tabindex="-1"]');
      if (f) { try { f.focus({ preventScroll: true }); } catch (e) {} }
      return true;
    }

    // ---------- Make page ----------
    function renderMake(rows) {
      var list = root.querySelector('[data-vh-models]');
      var chipOf = {}; cfg.forEach(function (c) { chipOf[c.category] = c.chip; });
      var allMine = rows.filter(function (r) { return r.makeKey === handle && chipOf[r.cat]; });
      // ?type=carplay (from the search): only models that have that product.
      var t = urlType && allMine.some(function (r) { return inType(urlType, r.cat); }) ? urlType : null;
      activeType = t;
      var mine = allMine.filter(function (r) { return inType(t, r.cat); });
      if (t) typeNote(list, 'Showing ' + esc(title) + ' models we carry <strong>' + esc(t.label) + '</strong> for.' + (MISS.text ? '<span class="lds-vh__typenote-miss">' + missHtml(t, title) + '</span>' : ''), 'Show all ' + title + ' models', function () { location.href = location.pathname; });
      var byModel = {};
      mine.forEach(function (r) {
        var m = byModel[r.key] || (byModel[r.key] = { name: r.model, ys: r.ys, ye: r.ye, cats: {} });
        m.ys = Math.min(m.ys, r.ys); m.ye = Math.max(m.ye, r.ye); m.cats[r.cat] = true;
      });
      // Boxes already on the page (with photos) for models we have rows for; others are hidden.
      var seen = {};
      Array.prototype.forEach.call(list.querySelectorAll('[data-vh-model]'), function (li) {
        var k = li.getAttribute('data-vh-model'); var m = byModel[k];
        if (!m) { li.hidden = true; return; }
        seen[k] = true; fill(li, m);
        if (li.getAttribute('data-vh-page') === '0') noPage(li, k);
      });
      // Models in the file without a box yet get one, with a placeholder instead of a photo.
      Object.keys(byModel).forEach(function (k) {
        if (seen[k]) return;
        var m = byModel[k];
        var li = document.createElement('li');
        li.className = 'lds-vh__card'; li.setAttribute('data-vh-model', k); li.setAttribute('data-name', m.name);
        li.innerHTML = '<a class="lds-vh__model" href="/collections/' + esc(k) + '"><h3 class="lds-vh__model-name">' + esc(m.name) + '</h3><div class="lds-vh__media">' + tpl('ph') + '</div><div class="lds-vh__model-body"><span class="lds-vh__span" data-vh-span></span><ul class="lds-vh__chips" role="list" data-vh-chips></ul><span class="lds-vh__go">' + esc(root.dataset.cta || 'See what fits') + tpl('arrow') + '</span></div></a>';
        list.appendChild(li); fill(li, m);
        // No photo box means we can't tell from the page whether the model page exists, so ask.
        fetch('/collections/' + encodeURIComponent(k), { method: 'HEAD', credentials: 'same-origin' })
          .then(function (r) { if (r.status === 404) noPage(li, k); }).catch(function () {});
      });
      // Alphabetical, the way people scan a model list.
      Array.prototype.slice.call(list.children).sort(function (a, b) {
        return (a.getAttribute('data-name') || '').localeCompare(b.getAttribute('data-name') || '', 'en', { numeric: true });
      }).forEach(function (li) { list.appendChild(li); });
      if (!Object.keys(byModel).length) root.querySelector('[data-vh-empty]').hidden = false;

      // Model with no model page yet: link straight to its one page if it only has one, otherwise hide the box.
      function noPage(li, k) {
        var rs = mine.filter(function (r) { return r.key === k; });
        var pages = {}; rs.forEach(function (r) { if (r.page) pages[r.page] = 1; });
        var only = Object.keys(pages);
        if (only.length === 1 && rs.every(function (r) { return r.page; })) { li.querySelector('a').setAttribute('href', only[0]); return; }
        li.hidden = true;
        console.warn('[vehicle hub] No model page for /collections/' + k + ', so its box is hidden. Create the collection to show it.');
      }

      function fill(li, m) {
        li.querySelector('[data-vh-span]').textContent = yearsLabel(m.ys, m.ye);
        li.querySelector('[data-vh-chips]').innerHTML = cfg.filter(function (c) { return m.cats[c.category]; })
          .map(function (c) { return '<li>' + esc(c.chip) + '</li>'; }).join('');
        var a = li.querySelector('a'), k = li.getAttribute('data-vh-model');
        a.setAttribute('aria-label', title + ' ' + m.name + ', ' + yearsLabel(m.ys, m.ye) + ': ' + cfg.filter(function (c) { return m.cats[c.category]; }).map(function (c) { return c.chip; }).join(', '));
        if (t && a.getAttribute('href') === '/collections/' + k) a.setAttribute('href', withType('/collections/' + k, t));
      }
    }

    // ---------- Search by Vehicle page ----------
    function renderSearch(rows) {
      var form = root.querySelector('[data-vh-ymm]');
      var selMake = root.querySelector('[data-vh-s-make]'), selModel = root.querySelector('[data-vh-s-model]'), selYear = root.querySelector('[data-vh-s-year]');
      var go = root.querySelector('[data-vh-s-go]'), msg = root.querySelector('[data-vh-s-msg]');
      var typesBox = root.querySelector('[data-vh-types]');
      var miss = document.createElement('p');
      miss.className = 'lds-vh__miss'; miss.hidden = true; miss.setAttribute('aria-live', 'polite');
      go.parentNode.insertBefore(miss, go.nextSibling);
      // Shown only while a product type is picked, since that's when a vehicle can drop off the list.
      function missLine() {
        miss.innerHTML = cur ? missHtml(cur, selMake.value ? names[selMake.value] : '') : '';
        miss.hidden = !miss.innerHTML;
      }
      // Product types with at least one vehicle in the file; ?type=carplay picks one on arrival.
      var avail = TYPES.filter(function (t) { return rows.some(function (r) { return inType(t, r.cat); }); });
      var cur = urlType && avail.indexOf(urlType) > -1 ? urlType : null;
      activeType = cur;
      var names = {}, makes = {}, models = {};
      rows.forEach(function (r) { names[r.makeKey] = names[r.makeKey] || r.make; });
      // Makes and models that have the chosen product type (or anything, with no type chosen).
      function build() {
        makes = {}; models = {};
        rows.forEach(function (r) {
          if (!inType(cur, r.cat)) return;
          makes[r.makeKey] = names[r.makeKey];
          var m = models[r.key] || (models[r.key] = { make: r.makeKey, name: r.model, ys: r.ys, ye: r.ye });
          m.ys = Math.min(m.ys, r.ys); m.ye = Math.max(m.ye, r.ye);
        });
      }
      function byName(a, b) { return a[1].localeCompare(b[1], 'en', { numeric: true }); }
      function fillSelect(sel, pairs, first) {
        sel.innerHTML = '<option value="">' + esc(first) + '</option>' + pairs.map(function (p) { return '<option value="' + esc(p[0]) + '">' + esc(p[1]) + '</option>'; }).join('');
      }
      // With a product picked, the Make label says how many makes have it: "Make (35 with CarPlay)".
      // (In the label, not the dropdown, so it never gets cut off.)
      var makeHint = null;
      (function () {
        var lab = selMake.closest ? selMake.closest('label') : null, tn = lab && lab.firstChild;
        if (!tn || tn.nodeType !== 3 || !tn.textContent.trim()) return;
        var row = document.createElement('span');
        row.className = 'lds-vh__label-row';
        row.appendChild(document.createTextNode(tn.textContent.trim() + ' '));
        makeHint = document.createElement('span');
        makeHint.className = 'lds-vh__hint';
        row.appendChild(makeHint);
        lab.replaceChild(row, tn);
      })();
      function fillMakes() {
        var n = Object.keys(makes).length;
        fillSelect(selMake, Object.keys(makes).map(function (k) { return [k, makes[k]]; }).sort(byName), 'Choose make');
        if (makeHint) makeHint.textContent = cur ? '(' + n + ' with ' + cur.label + ')' : '';
      }
      function onMake() {
        var mk = selMake.value;
        fillSelect(selModel, Object.keys(models).filter(function (k) { return models[k].make === mk; }).map(function (k) { return [k, models[k].name]; }).sort(byName), 'Choose model');
        selModel.disabled = !mk;
        fillSelect(selYear, [], 'Any year'); selYear.disabled = true;
        go.disabled = true; msg.textContent = '';
        missLine();
      }
      function onModel() {
        var m = models[selModel.value], years = [];
        if (m) for (var y = m.ye; y >= m.ys; y--) years.push([String(y), String(y)]);
        fillSelect(selYear, years, 'Any year');
        selYear.disabled = !m; go.disabled = !m; msg.textContent = '';
      }
      selMake.addEventListener('change', onMake);
      selModel.addEventListener('change', onModel);

      // After a type change, keep the make, model and year already picked when they still have that product.
      function refill() {
        var pm = selMake.value, pd = selModel.value, py = selYear.value;
        fillMakes();
        if (makes[pm]) selMake.value = pm;
        onMake();
        var m = models[pd];
        if (m && m.make === selMake.value) {
          selModel.value = pd; onModel();
          if (py && +py >= m.ys && +py <= m.ye) selYear.value = py;
        }
      }

      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var key = selModel.value, year = selYear.value, m = models[key];
        if (!m) return;
        var target = withType('/collections/' + encodeURIComponent(key) + (year ? '?year=' + year : ''), cur);
        go.setAttribute('aria-busy', 'true');
        // Most models have a model page. For the few that don't yet, go straight to the one page that fits, or to the make page.
        fetch('/collections/' + encodeURIComponent(key), { method: 'HEAD', credentials: 'same-origin' })
          .then(function (r) { return r.status !== 404; }).catch(function () { return true; })
          .then(function (hasPage) {
            if (hasPage) { location.href = target; return; }
            var y = parseInt(year, 10) || 0, pages = {};
            rows.forEach(function (r) { if (r.key === key && inType(cur, r.cat) && r.page && (!y || (r.ys <= y && r.ye >= y))) pages[r.page] = 1; });
            var list = Object.keys(pages);
            if (list.length === 1) { location.href = list[0]; return; }
            go.removeAttribute('aria-busy');
            msg.innerHTML = 'We\'re still building the ' + esc(names[m.make] + ' ' + m.name) + ' page. <a href="' + esc(withType('/collections/' + m.make, cur)) + '">See every ' + esc(names[m.make]) + ' model we cover</a>, or ask us below.';
          });
      });

      // Make tiles: how many models each make covers (for the chosen type), and hide makes with none.
      function tiles() {
        var counts = {};
        Object.keys(models).forEach(function (k) { counts[models[k].make] = (counts[models[k].make] || 0) + 1; });
        Array.prototype.forEach.call(root.querySelectorAll('[data-vh-make]'), function (li) {
          var n = counts[li.getAttribute('data-vh-make')] || 0;
          li.hidden = !n;
          if (!n) return;
          li.querySelector('[data-vh-count]').textContent = n + (n === 1 ? ' model' : ' models');
          var a = li.querySelector('a');
          if (!a.hasAttribute('data-base')) a.setAttribute('data-base', a.getAttribute('href'));
          a.setAttribute('href', withType(a.getAttribute('data-base'), cur));
        });
      }

      // "What are you looking for?" buttons above the dropdowns.
      if (typesBox && avail.length > 1) {
        var lab = root.dataset.typesLabel || 'What are you looking for?', allLab = root.dataset.typesAll || 'Everything';
        typesBox.innerHTML = '<span class="lds-vh__types-label" id="vh-types-' + sid + '">' + esc(lab) + '</span><div class="lds-vh__types-list" role="group" aria-labelledby="vh-types-' + sid + '">' +
          [{ key: '', label: allLab }].concat(avail).map(function (t) {
            return '<button type="button" class="lds-vh__type" data-type="' + esc(t.key) + '" aria-pressed="' + ((cur ? cur.key : '') === t.key) + '">' + esc(t.label) + '</button>';
          }).join('') + '</div>';
        typesBox.hidden = false;
        typesBox.addEventListener('click', function (e) {
          var b = e.target.closest ? e.target.closest('[data-type]') : null;
          if (!b) return;
          cur = typeByKey(b.getAttribute('data-type')); activeType = cur;
          Array.prototype.forEach.call(typesBox.querySelectorAll('[data-type]'), function (x) { x.setAttribute('aria-pressed', String(x === b)); });
          build(); refill(); tiles(); missLine();
          if (mode === 'search') setUrlType(cur);
        });
      }

      build(); fillMakes(); tiles(); missLine();
      // ?make=honda (and &model=honda-civic) pre-fill the dropdowns, for links from other pages.
      var params = new URLSearchParams(location.search);
      if (params.get('make') && makes[params.get('make')]) {
        selMake.value = params.get('make'); onMake();
        if (params.get('model') && models[params.get('model')] && models[params.get('model')].make === selMake.value) { selModel.value = params.get('model'); onModel(); }
      }
    }

    // ---------- Model page ----------
    var productCache = {};
    function getProduct(h) {
      if (!productCache[h]) {
        productCache[h] = fetch('/products/' + encodeURIComponent(h) + '.js', { credentials: 'same-origin' })
          .then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; });
      }
      return productCache[h];
    }
    function money(cents) { return (cents / 100).toLocaleString('en-CA', { style: 'currency', currency: 'CAD' }); }

    // ---------- Factory radio help (CarPlay boxes) ----------
    // Each year line in the boxes listed under "Boxes that show the factory radio" gets a "Factory radio: NBT,
    // How to tell" toggle, with a button to that radio on the make's radio guide page (/pages/...#radio-...).
    // The guide's radios load from /pages/<guide>?view=radios-json (templates/page.radios-json.liquid).
    var RG = { cfg: null, guide: null, radios: null, rows: [], year: 0 };
    try { RG.cfg = JSON.parse((root.querySelector('[data-vh-radio-cfg]') || {}).textContent || 'null'); } catch (e) { RG.cfg = null; }
    function rgText(k, d) { return (RG.cfg && RG.cfg[k]) || d; }
    function rgCats() { return String((RG.cfg && RG.cfg.cats) || '').split(',').map(function (x) { return x.trim(); }).filter(Boolean); }
    function makeAliases(make) {
      var l = String(make || '').toLowerCase(), out = [l];
      if (l === 'dodge') out.push('ram');
      if (l === 'ram') out.push('dodge');
      if (l === 'mercedes') out.push('mercedes-benz');
      return out;
    }
    // radio-match-start (also run by the local test script)
    var RADIO_NEG = /(no|without|non)[\s-]*$/i;
    function radioYears(s) {
      s = String(s || '').toLowerCase();
      var ys = (s.match(/(?:19|20)\d\d/g) || []).map(Number);
      if (!ys.length) return null;
      var lo = Math.min.apply(null, ys), hi = Math.max.apply(null, ys);
      if (ys.length === 1 && /and newer|and later|\bon\b|onward|\+/.test(s)) hi = 2100;
      if (ys.length === 1 && /up to|before|and older/.test(s)) lo = 1900;
      return [lo, hi];
    }
    function radioOverlap(a, b) { return !!(a && b && a[0] <= b[1] && b[0] <= a[1]); }
    function wordRe(w) { return new RegExp('(^|[^a-z0-9])' + String(w).replace(/[.*+?^${}()|[\]\\]/g, '\\$&') + '($|[^a-z0-9])'); }
    function radioLines(x) { return String(x.m || '').split(/\r?\n/).filter(function (l) { return l.trim(); }); }
    // Which of the guide's radios a fitment row is for: shared products first, then the radio's match terms in the
    // row's Variant (longest wins, "No NAV" style negatives skipped), then make, model lines and years.
    function pickRadios(r, year, all) {
      var mk = String(r.make || '').toLowerCase(), names = makeAliases(r.make);
      var v = String(r.variant || '').toLowerCase();
      var ys = year ? [year, year] : [r.ys, r.ye];
      var pool = all.filter(function (x) { return (x.mk || []).some(function (m) { return names.indexOf(String(m).toLowerCase()) > -1; }); });
      var P = pool.filter(function (x) { return (x.p || []).some(function (h) { return r.products.indexOf(String(h).toLowerCase()) > -1; }); });
      var C = P.length ? P : pool;
      var best = [], score = 0;
      C.forEach(function (x) {
        var s = 0;
        (x.t || []).forEach(function (t) {
          var tl = String(t).toLowerCase(), i = v.indexOf(tl);
          if (i < 0) return;
          if (!/^(no|without|non)\b/.test(tl) && RADIO_NEG.test(v.slice(0, i))) return;
          s = Math.max(s, tl.length);
        });
        if (s > score) { best = [x]; score = s; } else if (s === score && s > 0) best.push(x);
      });
      if (best.length) C = best; else if (!P.length) return [];
      // Drop radios whose every model line names another make; prefer radios whose lines name this make.
      var G = [];
      C.forEach(function (x) { (x.mk || []).forEach(function (m) { m = String(m).toLowerCase(); if (G.indexOf(m) < 0) G.push(m); }); });
      G.sort(function (a, b) { return b.length - a.length; });
      function named(line) { var l = line.toLowerCase(); return G.filter(function (m) { return wordRe(m).test(l); }); }
      C = C.filter(function (x) {
        var ln = radioLines(x).map(named);
        return !(ln.length && ln.every(function (n) { return n.length && n.indexOf(mk) < 0; }));
      });
      var pref = C.filter(function (x) { return radioLines(x).some(function (l) { return named(l).indexOf(mk) > -1; }); });
      if (pref.length && pref.length < C.length) C = pref;
      function hit(x, w) { var rx = wordRe(w); return radioLines(x).some(function (l) { return rx.test(l.toLowerCase()) && radioOverlap(radioYears(l), ys); }); }
      var ml = String(r.model || '').toLowerCase();
      if (C.length > 1) {
        var H = C.filter(function (x) { return hit(x, ml); });
        if (!H.length) { var f = ml.split(/\s+/)[0]; if (f.length > 1) H = C.filter(function (x) { return hit(x, f); }); }
        C = H.length ? H : C.filter(function (x) { return radioOverlap(radioYears(x.y), ys); });
      } else if (C.length) {
        if (!(radioOverlap(radioYears(C[0].y), ys) || hit(C[0], ml))) C = [];
      }
      return C;
    }
    // radio-match-end
    function radioHtml(C) {
      if (!C.length || C.length > 3 || !RG.guide) return '';
      var names = C.map(function (x) { return '<strong>' + esc(x.n) + '</strong>'; });
      var list = names.length > 1 ? names.slice(0, -1).join(', ') + ' ' + esc(rgText('or', 'or')) + ' ' + names[names.length - 1] : names[0];
      var lead = C.length === 1 ? rgText('label', 'Factory radio') : rgText('which', 'Which radio is yours?');
      var body = C.map(function (x) {
        return '<div class="lds-vh__radio-opt">' + (C.length > 1 ? '<p class="lds-vh__radio-name">' + esc(x.n) + '</p>' : '') +
          (x.s ? '<p>' + esc(x.s) + '</p>' : '') +
          '<a class="lds-vh__radio-btn" href="' + esc(RG.guide.url + '#radio-' + x.h) + '">' + esc(rgText('btn', 'Open the radio guide')) + CTA_ARROW + '</a></div>';
      }).join('');
      return '<details class="lds-vh__radio"><summary><span class="lds-vh__radio-sum"><span class="lds-vh__radio-k">' + esc(lead) + (/[?:]$/.test(lead) ? '' : ':') + '</span> ' + list + '</span>' +
        '<span class="lds-vh__radio-how">' + esc(rgText('how', 'How to tell')) + '</span></summary><div class="lds-vh__radio-body">' + body + '</div></details>';
    }
    function fillRadios() {
      if (!RG.radios) return;
      Array.prototype.forEach.call(root.querySelectorAll('[data-vh-radio]'), function (slot) {
        var r = RG.rows[+slot.getAttribute('data-vh-radio')];
        if (r) slot.innerHTML = radioHtml(pickRadios(r, RG.year, RG.radios));
      });
    }
    function startRadios(own, cats) {
      if (!RG.cfg || !own) return;
      var want = rgCats();
      if (!want.length || !cats.some(function (c) { return want.indexOf(c.category) > -1; })) return;
      var names = makeAliases(own.make);
      RG.guide = (RG.cfg.guides || []).filter(function (g) { return (g.makes || []).some(function (m) { return names.indexOf(String(m).toLowerCase()) > -1; }); })[0] || null;
      if (!RG.guide) return;
      fetch(RG.guide.url + '?view=radios-json', { credentials: 'same-origin' })
        .then(function (r) { if (!r.ok) throw new Error('Radio guide ' + r.status); return r.text(); })
        .then(function (t) { var j = JSON.parse(t.slice(t.indexOf('{'), t.lastIndexOf('}') + 1)); RG.radios = (j && j.radios) || []; fillRadios(); })
        .catch(function (e) { console.warn('[vehicle hub] radio guide', e); });
    }

    function renderModel(rows) {
      var grid = root.querySelector('[data-vh-cats]');
      var mine = rows.filter(function (r) { return r.key === handle; });
      var cfgCats = cfg.filter(function (c) { return mine.some(function (r) { return r.cat === c.category; }); });
      var yearBox = root.querySelector('[data-vh-year]');
      var sel = root.querySelector('[data-vh-year-select]');
      var note = root.querySelector('[data-vh-year-note]');
      var jump = root.querySelector('[data-vh-jump]'), jumpList = root.querySelector('[data-vh-jump-list]');

      // Back to the make page / search page. The page sets these from the Vehicle Model entry when it can;
      // otherwise use the make in the fitment file.
      var own = mine.filter(function (r) { return !r.paired; })[0] || mine[0];
      var back = root.querySelector('[data-vh-back-make]'), srch = root.querySelector('[data-vh-back-search]');
      if (back && back.hidden && own) {
        back.setAttribute('href', '/collections/' + own.makeKey);
        back.querySelector('[data-vh-make-label]').textContent = (root.dataset.backTpl || 'All [make] models').replace('[make]', own.make);
        back.hidden = false;
      }
      if (srch && own && srch.getAttribute('href').indexOf('make=') < 0) {
        srch.setAttribute('href', srch.getAttribute('href').split('?')[0] + '?make=' + encodeURIComponent(own.makeKey) + '&model=' + encodeURIComponent(handle));
      }
      root.addEventListener('click', function (e) {
        var a = e.target.closest ? e.target.closest('[data-vh-scroll]') : null;
        if (a && scrollToId(a.getAttribute('data-vh-scroll'))) e.preventDefault();
      });
      if (!cfgCats.length) {
        grid.innerHTML = ''; grid.hidden = true; root.querySelector('[data-vh-empty]').hidden = false;
        // Keep the VIN checker available: it can still take the shopper to the right model.
        if (root.querySelector('[data-vh-vin]')) {
          yearBox.hidden = false;
          Array.prototype.forEach.call(yearBox.querySelectorAll('label[for^="vh-year"], [data-vh-year-select], [data-vh-year-note], .lds-vh__or'), function (el) { el.hidden = true; });
        }
        return;
      }

      var minY = Math.min.apply(null, mine.map(function (r) { return r.ys; }));
      var maxY = Math.max.apply(null, mine.map(function (r) { return r.ye; }));
      for (var y = maxY; y >= minY; y--) { var o = document.createElement('option'); o.value = y; o.textContent = y; sel.appendChild(o); }
      yearBox.hidden = false;
      var params = new URLSearchParams(location.search);
      var want = parseInt(params.get('year'), 10);
      if (want >= minY && want <= maxY) sel.value = String(want);

      sel.addEventListener('change', function () {
        var u = new URL(location.href);
        if (sel.value) u.searchParams.set('year', sel.value); else u.searchParams.delete('year');
        history.replaceState(null, '', u.pathname + u.search + u.hash);
        draw();
      });
      // ?type=carplay (from the search): only those boxes, with a way back to everything.
      var tFilter = urlType && cfgCats.some(function (c) { return inType(urlType, c.category); }) ? urlType : null;
      activeType = tFilter;
      if (tFilter) {
        var tNote = typeNote(jump || grid, 'Showing <strong>' + esc(tFilter.label) + '</strong> for the ' + esc(title) + '.', 'Show everything for the ' + title, function () {
          tFilter = null; activeType = null; setUrlType(null); tNote.remove(); draw();
        });
      }
      startRadios(own, cfgCats);
      pinJump();
      draw();

      // "Jump to" bar: once the buttons scroll away, a slim copy pins under the site header while the
      // boxes are on screen (same look as the Guided pages' quick links), with the box in view marked.
      function pinJump() {
        if (!jump) return;
        pinEl = document.createElement('div');
        pinEl.className = 'lds-vh-pin';
        pinEl.innerHTML = '<nav class="lds-vh-pin__bar" aria-label="' + esc(jump.getAttribute('aria-label') || 'Jump to') + '"><span class="lds-vh-pin__label" aria-hidden="true">' + esc(jump.querySelector('.lds-vh__jump-label') ? jump.querySelector('.lds-vh__jump-label').textContent : 'Jump to') + '</span><ul role="list" data-vh-pin-list></ul><a class="lds-vh-pin__top" href="#" data-vh-pin-top aria-label="' + esc(root.dataset.top || 'Back to top') + '">&uarr;</a></nav>';
        document.body.appendChild(pinEl);
        var pinList = pinEl.querySelector('[data-vh-pin-list]'), raf = 0, last = null;
        pinEl.addEventListener('click', function (e) {
          var a = e.target.closest ? e.target.closest('[data-vh-scroll], [data-vh-pin-top]') : null;
          if (!a) return;
          e.preventDefault();
          if (a.hasAttribute('data-vh-pin-top')) { window.scrollTo({ top: 0, behavior: 'smooth' }); return; }
          scrollToId(a.getAttribute('data-vh-scroll'));
        });
        function fill() {
          pinList.innerHTML = Array.prototype.map.call(jumpList.querySelectorAll('[data-vh-scroll]'), function (a) {
            return '<li><a class="lds-vh-pin__link" href="#' + esc(a.getAttribute('data-vh-scroll')) + '" data-vh-scroll="' + esc(a.getAttribute('data-vh-scroll')) + '">' + esc(a.firstChild ? a.firstChild.textContent : a.textContent) + '</a></li>';
          }).join('');
          last = null; ask();
        }
        function update() {
          raf = 0;
          var stick = Math.round(headerOffset());
          pinEl.style.setProperty('--vh-pin-top', stick + 'px');
          var on = !jump.hidden && jump.getBoundingClientRect().bottom < stick + 4 && grid.getBoundingClientRect().bottom > stick + pinEl.firstElementChild.offsetHeight + 80;
          pinEl.classList.toggle('is-on', on);
          // The box in view: the last one whose top has passed the pinned bar.
          var line = stick + pinEl.firstElementChild.offsetHeight + 56, cur = null;
          Array.prototype.forEach.call(grid.querySelectorAll('.lds-vh__card'), function (card) { if (card.getBoundingClientRect().top <= line) cur = card.id; });
          if (cur === last) return;
          last = cur;
          Array.prototype.forEach.call(root.querySelectorAll('.lds-vh__jump-btn'), function (a) { a.classList.toggle('is-current', a.getAttribute('data-vh-scroll') === cur); });
          Array.prototype.forEach.call(pinList.querySelectorAll('[data-vh-scroll]'), function (a) {
            var hit = a.getAttribute('data-vh-scroll') === cur;
            if (hit) a.setAttribute('aria-current', 'true'); else a.removeAttribute('aria-current');
            if (hit && pinList.scrollWidth > pinList.clientWidth) pinList.scrollLeft = Math.max(0, a.parentNode.offsetLeft - (pinList.clientWidth - a.offsetWidth) / 2);
          });
          edge();
        }
        function ask() { if (!raf) raf = requestAnimationFrame(update); }
        // Fade the right edge while more links are hidden off to the side (phones).
        function edge() { pinList.classList.toggle('is-more', pinList.scrollLeft + pinList.clientWidth < pinList.scrollWidth - 4); }
        pinList.addEventListener('scroll', edge, { passive: true });
        window.addEventListener('scroll', ask, { passive: true });
        window.addEventListener('resize', function () { ask(); edge(); });
        root.addEventListener('vh:drawn', function () { fill(); edge(); });
      }

      function draw() {
        var year = parseInt(sel.value, 10) || 0;
        var groups = cfgCats.filter(function (c) { return inType(tFilter, c.category); }).map(function (c) {
          var rs = mine.filter(function (r) { return r.cat === c.category && (!year || (r.ys <= year && r.ye >= year)); })
            .sort(function (a, b) { return a.ys - b.ys || a.ye - b.ye || a.start.localeCompare(b.start); }); // oldest first, like a timeline
          return { c: c, rs: dedupe(rs) };
        }).filter(function (g) { return g.rs.length; });
        var shown = groups.length;
        // Two or more boxes: a row of buttons that scroll to each, and "Back to top" in each box goes back to it.
        var many = shown > 1;
        var topId = many ? 'vh-jump-' + sid : 'vh-title-' + sid;
        RG.rows = []; RG.year = year;
        grid.innerHTML = groups.map(function (g) { return card(g.c, g.rs, topId); }).join('');
        fillRadios();
        if (jump) {
          jumpList.innerHTML = groups.map(function (g) {
            var id = catId(g.c);
            return '<li><a class="lds-vh__jump-btn" href="#' + id + '" data-vh-scroll="' + id + '">' + esc(g.c.chip || g.c.title) + '<span class="lds-vh__jump-arrow" aria-hidden="true">↓</span></a></li>';
          }).join('');
          jump.hidden = !many;
        }
        // One status line under the year and VIN boxes that always takes the same space (no page jump):
        // the VIN hint by default, then what the year picker or VIN check did.
        var hintEl = root.querySelector('.lds-vh__vin-help');
        note.classList.remove('is-error');
        note.textContent = year ? (shown ? 'Showing only what fits a ' + year + ' ' + title + '.' : 'Nothing listed for a ' + year + ' ' + title + ' yet. Choose All years, or ask us below.') : (hintEl ? hintEl.textContent : '');
        grid.hidden = !shown && !year;
        hydrateProducts();
        try { root.dispatchEvent(new CustomEvent('vh:drawn')); } catch (e) {}
      }
    }

    var ICONS = {
      remote: '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="7" y="2" width="10" height="15" rx="4"/><circle cx="12" cy="7" r="1.6"/><path d="M10.5 11.5h3"/><path d="M12 17v2"/><circle cx="12" cy="20.5" r="1.5"/></svg>',
      stereo: '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="2" y="6" width="20" height="12" rx="2"/><circle cx="8" cy="12" r="2.5"/><path d="M14 10h5M14 14h5"/></svg>',
      screen: '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="3" y="4" width="18" height="13" rx="2"/><path d="M8 21h8M12 17v4"/></svg>',
      camera: '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M3 8h4l2-3h6l2 3h4v11H3z"/><circle cx="12" cy="13" r="3.5"/></svg>',
      liftgate: '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M3 17h18v3H3z"/><path d="M5 17V9l7-5 7 5"/><path d="M12 8v6M9.5 11.5 12 14l2.5-2.5"/></svg>',
      light: '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M9 18h6M10 21h4"/><path d="M12 3a6 6 0 0 0-3.5 10.9V16h7v-2.1A6 6 0 0 0 12 3z"/></svg>',
      bluetooth: '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M7 7l10 10-5 5V2l5 5L7 17"/></svg>',
      speaker: '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="5" y="2" width="14" height="20" rx="2"/><circle cx="12" cy="14" r="4"/><circle cx="12" cy="6.5" r="1"/></svg>'
    };

    // Button on each year row: the box's "Row button" setting, else "See " + its short name (See remote starters).
    var CTA_ARROW = '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12h14M13 6l6 6-6 6"/></svg>';
    function rowLabel(c) {
      if (c.row_label) return c.row_label;
      var name = String(c.chip || c.title || '').trim();
      if (!name) return 'See what fits';
      var first = name.split(/\s+/)[0];
      // Lower-case the first letter unless it's a name like CarPlay or Bluetooth.
      if (!/[A-Z]/.test(first.slice(1)) && !/^(Bluetooth|Android|Apple)$/.test(first)) name = name.charAt(0).toLowerCase() + name.slice(1);
      return 'See ' + name;
    }

    function catId(c) { return 'vh-cat-' + sid + '-' + slug(c.category); }
    // Paired models can bring the same page twice (once per side): keep one row per page and years.
    function dedupe(rs) {
      var seen = {};
      return rs.filter(function (r) {
        var k = r.page ? r.page + '|' + r.ys + '|' + r.ye + '|' + r.start + '|' + r.variant : null;
        if (!k) return true;
        if (seen[k]) return false;
        seen[k] = 1; return true;
      });
    }

    function card(c, rs, topId) {
      var head = '<div class="lds-vh__card-head">' + (c.icon && ICONS[c.icon] ? '<span class="lds-vh__icon">' + ICONS[c.icon] + '</span>' : '') +
        '<div><h3 class="lds-vh__card-title" tabindex="-1">' + esc(c.title) + '</h3>' + (c.text ? '<p class="lds-vh__card-text">' + esc(c.text) + '</p>' : '') + '</div></div>';
      // What the category is: one optional video or picture across the top, and a short checklist under the description.
      var banner = c.video ? '<div class="lds-vh__banner">' + c.video + '</div>' : (c.banner ? '<div class="lds-vh__banner"><img src="' + esc(c.banner) + '" alt="" loading="lazy"></div>' : '');
      var kit = (c.kit || []).filter(Boolean);
      var isRadio = !!(RG.guide && rgCats().indexOf(c.category) > -1);
      var note = isRadio ? '<p class="lds-vh__radio-note">' + esc(rgText('note', 'Not sure which factory radio you have?')) + ' <a href="' + esc(RG.guide.url) + '">' + esc(rgText('note_link', 'See how to tell')) + '</a></p>' : '';
      var explain = (kit.length || note) ? '<div class="lds-vh__explain">' + (kit.length ? (c.parts_title ? '<p class="lds-vh__explain-title">' + esc(c.parts_title) + '</p>' : '') +
        '<ul class="lds-vh__kit" role="list">' + kit.map(function (t) {
          return '<li><svg viewBox="0 0 16 16" width="15" height="15" aria-hidden="true" focusable="false"><path d="M3 8.5l3.2 3L13 4.5" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"/></svg><span>' + esc(t) + '</span></li>';
        }).join('') + '</ul>' : '') + note + '</div>' : '';
      head = banner + head + explain;
      var items = rs.map(function (r) {
        var years = yearsLabel(r.ys, r.ye);
        var sub = r.start || r.variant;
        var icon = /push/i.test(r.start) ? tpl('ico-push') : (/key/i.test(r.start) ? tpl('ico-key') : '');
        var subHtml = sub ? '<span class="lds-vh__sub">' + icon + esc(sub) + (r.start && r.variant ? ', ' + esc(r.variant) : '') + '</span>' : '';
        if (r.page) {
          return '<li><a class="lds-vh__row" href="' + esc(r.page) + '" aria-label="' + esc(rowLabel(c) + ': ' + c.title + ', ' + years + (sub ? ', ' + sub : '')) + '"><span class="lds-vh__row-main"><span class="lds-vh__years">' + years + '</span>' + subHtml + '</span><span class="lds-vh__cta" aria-hidden="true">' + esc(rowLabel(c)) + CTA_ARROW + '</span></a></li>';
        }
        var prods = r.products.slice().sort(function (a, b) { return (b === r.preferred) - (a === r.preferred); });
        return '<li class="lds-vh__group"><span class="lds-vh__group-label">' + years + '</span>' + (sub ? '<span class="lds-vh__group-sub">' + esc(sub) + '</span>' : '') +
          (isRadio ? '<div class="lds-vh__radio-slot" data-vh-radio="' + (RG.rows.push(r) - 1) + '"></div>' : '') +
          '<ul class="lds-vh__prods" role="list">' + prods.map(function (h) { return '<li data-vh-prod="' + esc(h) + '" hidden></li>'; }).join('') + '</ul></li>';
      }).join('');
      // Each box is one full-width band: a black side panel (title, description, "All …" link) and the
      // year tiles beside it. On phones the panel sits on top and the years run down the page.
      var more = c.more_link ? '<div class="lds-vh__card-foot"><a class="lds-vh__more" href="' + esc(c.more_link) + '">' + esc(c.more_label || ('All ' + c.title)) + '</a></div>' : '';
      return '<li class="lds-vh__card" id="' + catId(c) + '"><div class="lds-vh__card-side">' + head + more + '</div><div class="lds-vh__card-main"><ul class="lds-vh__rows" role="list">' + items + '</ul></div></li>';
    }

    function hydrateProducts() {
      Array.prototype.forEach.call(root.querySelectorAll('[data-vh-prod]'), function (li) {
        var h = li.getAttribute('data-vh-prod');
        getProduct(h).then(function (p) {
          if (!p) { li.remove(); return; } // Unknown or unpublished product: leave it out rather than link to a dead page.
          var img = p.featured_image ? p.featured_image + (p.featured_image.indexOf('?') > -1 ? '&' : '?') + 'width=120' : '';
          li.innerHTML = '<a class="lds-vh__prod" href="' + esc(p.url || ('/products/' + h)) + '">' +
            (img ? '<img src="' + esc(img) + '" alt="" width="56" height="56" loading="lazy">' : '<span></span>') +
            '<span class="lds-vh__prod-name">' + esc(p.title) + '</span>' +
            '<span class="lds-vh__prod-price">' + (p.available ? money(p.price) : 'Sold out') + '</span></a>';
          li.hidden = false;
        });
      });
    }

    // ---------- VIN checker ----------
    // The VIN is decoded by NHTSA's free public decoder (vPIC), then matched to our models by name.
    // VINs give year, make and model; key start vs push button isn't in a VIN, so the model page shows both.
    var ALL = [];
    function titleCase(s) { return String(s || '').toLowerCase().replace(/\b[a-z]/g, function (c) { return c.toUpperCase(); }); }
    function vinCandidates(make, model, extraWords) {
      var tries = (window.LDSVin && window.LDSVin.alts(make, model)) || [{ mk: slug(make), md: slug(model) }];
      var best = null;
      for (var i = 0; i < tries.length; i++) {
        var c = vinCandidatesFor(tries[i].mk, tries[i].md, extraWords);
        var top = c.reduce(function (a, x) { return Math.max(a, x.score); }, -1);
        if (c.length && (!best || top > best.top)) { best = { list: c, top: top }; best.list.mk = tries[i].mk; }
        if (best && best.top >= 1) break;
      }
      return best ? best.list : [];
    }
    function vinCandidatesFor(mk, md, extraWords) {
      var names = {}, out = [];
      ALL.forEach(function (r) { if (r.makeKey === mk) names[r.key] = r.model; });
      Object.keys(names).forEach(function (k) {
        var m = slug(names[k]);
        if (!md) return;
        if (m === md) out.push({ key: k, name: names[k], score: 1 });
        else if (m.indexOf(md + '-') === 0) {
          // We list a more specific model (Civic Type R, Civic Hatchback): pick it when the VIN's trim or body says so.
          var rest = m.slice(md.length + 1).split('-');
          out.push({ key: k, name: names[k], score: rest.every(function (w) { return extraWords.indexOf(w) >= 0; }) ? 2 : 0 });
        } else if (md.indexOf(m + '-') === 0) {
          out.push({ key: k, name: names[k], score: 0.5 }); // VIN is more specific than our model name (Sierra 1500 vs Sierra).
        }
      });
      return out;
    }
    function initVin() {
      Array.prototype.forEach.call(root.querySelectorAll('[data-vh-vin]'), function (form) {
        var input = form.querySelector('input'), btn = form.querySelector('button'), out = form.querySelector('[data-vh-vin-result]');
        function show(html, isError) { out.innerHTML = html; out.classList.toggle('is-error', !!isError); }
        // Model page: short messages go in the status line under the year picker, which never changes height.
        var line = mode === 'model' ? root.querySelector('[data-vh-year-note]') : null;
        function say(html, isError) {
          if (line && !line.hidden) { line.innerHTML = html; line.classList.toggle('is-error', !!isError); show(''); }
          else show('<p>' + html + '</p>', isError);
        }
        form.addEventListener('submit', function (e) {
          e.preventDefault();
          var vin = (input.value || '').toUpperCase().replace(/[^A-Z0-9]/g, '');
          input.value = vin;
          if (!/^[A-HJ-NPR-Z0-9]{17}$/.test(vin)) {
            say('A VIN is 17 letters and numbers, and never uses I, O or Q. Check it and try again.', true);
            input.focus(); return;
          }
          btn.setAttribute('aria-busy', 'true'); say('Checking your VIN…');
          fetch('https://vpic.nhtsa.dot.gov/api/vehicles/DecodeVinValues/' + vin + '?format=json')
            .then(function (r) { if (!r.ok) throw new Error('vPIC ' + r.status); return r.json(); })
            .then(function (j) {
              btn.removeAttribute('aria-busy');
              var v = (j && j.Results && j.Results[0]) || {};
              var year = parseInt(v.ModelYear, 10), make = v.Make, model = v.Model;
              if (!year || !make) { say('We couldn\'t read that VIN. Check the 17 characters and try again.', true); return; }
              var words = slug([v.Trim, v.Series, v.BodyClass, v.Trim2, v.Series2].join(' ')).split('-');
              var cands = vinCandidates(make, model, words);
              var vmk = cands.mk || slug(make);
              var makeName = (ALL.filter(function (r) { return r.makeKey === vmk; })[0] || {}).make || titleCase(make);
              var said = year + ' ' + makeName + (model ? ' ' + model : '');
              var best = cands.reduce(function (a, c) { return Math.max(a, c.score); }, 0);
              var winners = cands.filter(function (c) { return c.score === best && best >= 1; });
              if (winners.length === 1) {
                var w = winners[0];
                if (mode === 'model' && w.key === handle) {
                  var sel = root.querySelector('[data-vh-year-select]');
                  var has = sel && Array.prototype.some.call(sel.options, function (o) { return o.value === String(year); });
                  if (has) {
                    sel.value = String(year); sel.dispatchEvent(new Event('change'));
                    say('Your VIN is a <strong>' + esc(said) + '</strong>. Showing only what fits it.');
                  } else {
                    say('Your VIN is a <strong>' + esc(said) + '</strong>. Nothing listed for ' + year + ' yet: ask us below.', true);
                  }
                } else {
                  say('Your VIN is a <strong>' + esc(said) + '</strong>. Taking you to it…');
                  location.href = withType('/collections/' + encodeURIComponent(w.key) + '?year=' + year);
                }
                return;
              }
              if (cands.length) {
                show('<p>Your VIN is a <strong>' + esc(said) + '</strong>. Which of these is it?</p><div class="lds-vh__vin-picks">' +
                  cands.map(function (c) { return '<a class="lds-vh__vin-pick" href="' + esc(withType('/collections/' + c.key + '?year=' + year)) + '">' + esc(makeName + ' ' + c.name) + '</a>'; }).join('') + '</div>');
                return;
              }
              var mk = vmk, hasMake = ALL.some(function (r) { return r.makeKey === mk; });
              show('<p>Your VIN is a <strong>' + esc(said) + '</strong>. We don\'t have a page for it yet, but we can often source parts. Tell us below and we\'ll check what fits.</p>' +
                (hasMake ? '<p><a href="/collections/' + esc(mk) + '">See every ' + esc(makeName) + ' model we cover</a></p>' : ''), true);
            })
            .catch(function (err) {
              console.error('[vehicle hub] VIN', err);
              btn.removeAttribute('aria-busy');
              say('We couldn\'t check that VIN just now. Pick your year instead, or try again in a minute.', true);
            });
        });
      });
    }

    var started = false;
    function start() {
      if (started) return; started = true;
      load().then(function (rows) {
        ALL = rows;
        if (mode === 'make') renderMake(rows); else if (mode === 'search' || mode === 'home') renderSearch(rows); else renderModel(rows);
        initVin();
      }).catch(function (e) {
        console.error('[vehicle hub]', e);
        var grid = root.querySelector('[data-vh-cats]'); if (grid) grid.innerHTML = '';
        var msg = root.querySelector('[data-vh-empty]'); if (msg) msg.hidden = false;
        var sm = root.querySelector('[data-vh-s-msg]'); if (sm && !msg) sm.textContent = "Our vehicle list didn't load. Please refresh the page.";
      });
    }
    // Homepage: fetch the fitment file only when the box is close to the screen (or someone reaches for it),
    // so it doesn't slow down the first view of the page.
    if (mode === 'home' && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (es) {
        if (es.some(function (e) { return e.isIntersecting; })) { io.disconnect(); start(); }
      }, { rootMargin: '400px 0px' });
      io.observe(root);
      root.addEventListener('focusin', start);
      root.addEventListener('pointerdown', start);
    } else start();
  }

  function initAll() { Array.prototype.forEach.call(document.querySelectorAll('.lds-vh'), initHub); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll); else initAll();
  document.addEventListener('shopify:section:load', initAll);
})();
